import { render } from "./TableSetting.vue?vue&type=template&id=fb4afcd4"
import script from "./TableSetting.vue?vue&type=script&lang=jsx"
export * from "./TableSetting.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__